<template>
  <div class="v3-popup bag-popup score-detail-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content large">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ langData.myRewardsTitle }}</div>
      <div class="v3-popup-content-content">
        <table>
          <thead>
            <tr>
              <th>{{ langData.prizeNameLabel }}</th>
              <th>{{ langData.prizeQtyLabel }}</th>
              <th>{{ langData.obtainTimeLabel }}</th>
              <th>{{ langData.currentStatusLabel }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in awardLogList" :key="index">
              <td>{{ langData[awardConfig[item.AWARD_ID]] || awardConfig[item.AWARD_ID] }}</td>
              <td>{{ item.AWARD_NUM }}</td>
              <td>{{ item.CREATE_TIME }}</td>
              <td>
                <div
                  v-if="awardState(item).isVt && awardState(item).finished"
                  class="view-code-btn"
                  @click="viewCode(item)"
                >
                  {{ awardState(item).text }}
                </div>
                <span v-else>{{ awardState(item).text }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="v3-popup-content-footer">
        <div
          class="page-pre"
          :class="{ un: page <= 1 }"
          @click="handlePrevPage"
        ></div>
        <template v-for="(pageNum, index) in displayPages" :key="index">
          <div v-if="pageNum === '...'" class="page-num">...</div>
          <div
            v-else
            class="page-num"
            :class="{ active: pageNum === page }"
            @click="handlePageClick(pageNum)"
          >
            {{ pageNum }}
          </div>
        </template>
        <div
          class="page-next"
          :class="{ un: page >= totalPages }"
          @click="handleNextPage"
        ></div>
      </div>
      <div class="get-award-group">
        <div
          class="confirm-btn btns"
          :style="isLoading ? { pointerEvents: 'none' } : {}"
          @click="getVirtualAwardFn"
          v-if="lotteryAndTaskState.canClaimVirtualReward"
        >
          <svg v-if="isLoading" class="btn-spinner" width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 4V8" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M34 6.6795L32 10.1436" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M41.3203 14L37.8562 16" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M44 24H40" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M41.3203 34L37.8562 32" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M34 41.3205L32 37.8564" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 44V40" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 41.3205L16 37.8564" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.67969 34L10.1438 32" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 24H8" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.67969 14L10.1438 16" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 6.6795L16 10.1436" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <template v-else>{{ langData.claimVirtualBtn }}</template>
        </div>
        <div
          class="confirm-btn btns physical"
          :style="isLoading ? { pointerEvents: 'none' } : {}"
          @click="getPhysicalAwardFn"
          v-if="lotteryAndTaskState.canClaimMaterialReward"
        >
          <svg v-if="isLoading" class="btn-spinner" width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 4V8" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M34 6.6795L32 10.1436" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M41.3203 14L37.8562 16" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M44 24H40" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M41.3203 34L37.8562 32" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M34 41.3205L32 37.8564" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 44V40" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 41.3205L16 37.8564" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.67969 34L10.1438 32" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 24H8" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.67969 14L10.1438 16" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 6.6795L16 10.1436" stroke="#333" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <template v-else>{{ langData.claimPhysicalBtn }}</template>
        </div>
      </div>
      <p class="bag-popup-tips">{{ langData.claimTips }}</p>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, watch, ref } from "vue";
import { awardConfig } from "@/config";
import useGetAward from "@/hooks/useGetAward";
import LanguageHook from "@hooks/language";

const { langData } = LanguageHook();

const showCurErrorTips = inject("showCurErrorTips", () => {});
const showTipMessage = inject("showTipMessage", () => {});
const v3PopupState = inject("v3PopupState", reactive({}));
const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const {
  page,
  awardLogList,
  totalPages,
  displayPages,
  switchPage,
  initAwardList,
  resetAwardList,
  getVirtualAward,
  fillPhysicalAward,
  viewCode,
} = useGetAward((key) => showTipMessage(langData[key] || key), showCurErrorTips);

const initActivity = inject("initActivity", async () => {});

const isLoading = ref(false);

const getVirtualAwardFn = async () => {
  window.activityDataLayer.push({ eventName: "click_button", eventType: "领取虚拟奖励", eventReason: "我的奖品", aid: window.activity_name, gameId: window.game_id });
  isLoading.value = true;
  try {
    const res = await getVirtualAward();
    if (res) {
      lotteryAndTaskState.canClaimVirtualReward = false;
      await initActivity();
    }
  } finally {
    isLoading.value = false;
  }
};
const getPhysicalAwardFn = async () => {
  window.activityDataLayer.push({ eventName: "click_button", eventType: "领取实物奖励", eventReason: "我的奖品", aid: window.activity_name, gameId: window.game_id });
  isLoading.value = true;
  try {
    await fillPhysicalAward();
    await initActivity();
  } finally {
    isLoading.value = false;
  }
};

// 关闭弹窗
const handleClose = () => {
  v3PopupState.bagPopupState = false;
};

const awardState = (item) => {
  const isVt = item.AWARD_VT_TYPE === "sendVt";
  const state = item.AWARD_STATE;
  return {
    isVt,
    text: state == 1 ? langData.unclaimedStatus : isVt ? langData.viewGiftCodeBtn + ">>" : langData.claimedStatus,
    finished: state == 1 ? false : true,
  };
};

// 上一页
const handlePrevPage = () => {
  if (page.value > 1) {
    switchPage(page.value - 1);
  }
};

// 下一页
const handleNextPage = () => {
  if (page.value < totalPages.value) {
    switchPage(page.value + 1);
  }
};

// 点击页码
const handlePageClick = (pageNum) => {
  if (pageNum !== page.value && pageNum !== "...") {
    switchPage(pageNum);
  }
};

watch(
  () => v3PopupState.bagPopupState,
  (value) => {
    if (value) {
      initAwardList();
    } else {
      resetAwardList();
    }
  }
);
</script>

<style scoped lang="less">
.view-code-btn {
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
}

.btn-spinner {
  animation: btn-spin 0.8s linear infinite;
}

@keyframes btn-spin {
  to { transform: rotate(360deg); }
}
</style>
